import moment from 'moment';
import Chip from '../../../../../designSystem/Chip/Chip';
import Loading from '../../../../../commons/Loading/Loading';
import { getChipContentByStepId } from '../../../../../../utils/helpers/consultation/getChipContentByStepId';
import { useState } from 'react';
import Button from '../../../../../designSystem/Button/Button';
import { ButtonColor, ButtonSize } from '../../../../../designSystem/Button/Button.types';
import { useNavigate } from 'react-router-dom';
import { useCompanyConsultations } from "../../../../../../hooks/fetchers/useCompanyConsultations/useCompanyConsultations";
// import { useCompanyInProgressConsultations } from '../../../../../../hooks/fetchers/useCompanyInProgressConsultations/useCompanyInProgressConsultations';

export default () => {
  const navigate = useNavigate();

  const [currentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(11);

  const { data, isLoading } = useCompanyConsultations({
    page: currentPage,
    perPage: itemsPerPage,
  });

  return (
    <table className="dashboard__table">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <colgroup>
            <col style={{ width: '45%' }} />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>Titre</th>
              <th>Début</th>
              <th>Fin</th>
              <th>Status</th>
            </tr>
          </thead>
          {data ? (
            <tbody>
              {data?.results.map((consultation, index) => {
                const { title, start, end } = consultation;
                const { label, color } = getChipContentByStepId(consultation);
                if (index < 10) {
                  return (
                    <tr key={index}>
                      <td>{title}</td>
                      <td>{moment(start).format('DD-MM-YYYY')}</td>
                      <td>{moment(end).format('DD-MM-YYYY')}</td>
                      <td>
                        <Chip {...{ color }}>{label}</Chip>
                      </td>
                      {/* <td>{id_step}</td> */}
                    </tr>
                  );
                } else {
                  return null;
                }
              })}
            </tbody>
          ) : (
            <div style={{ position: 'absolute', width: '100%' }}>
              <h1
                style={{ color: 'var(--gray-4)', fontFamily: 'Quicksand-Medium', fontWeight: 400 }}>
                Votre historique est vide pour le moment
              </h1>
            </div>
          )}
          {data && data.total > 10 && (
            <Button
              className="dashboard__table-button--large"
              size={ButtonSize.Large}
              color={ButtonColor.Secondary}
              onClick={() => navigate('/dashboard/consultations_in_progress')}>
              Voir tout
            </Button>
          )}
        </>
      )}
    </table>
  );
};
